<template>
    <QuesBankform :bId="bId" :isSystem="isSystem" :bankType="bankType"></QuesBankform>
</template>

<script>

import QuesBankform from "@/page/examQuestionBank/components/quesBankform.vue"
export default {
    name: 'AddQuestionBankWJ',
    components: {
        QuesBankform
    },
    data() {
        return {

        }
    },
    computed:{
        bId() {
            return this.$route.query.bId
        },
        isSystem() {
            return this.$route.query.isSystem
        },
        bankType() {
            return this.$route.query.bankType
        }
    },
    created() {
    },
    methods:{
    }
}
</script>

<style lang="scss" scoped>
</style>
